function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
export default class CartController {
  constructor() {
    this.route = void 0;
    this.sections = [];
    this.parser = void 0;
    // global Shopify route
    this.route = window.Shopify.routes.root; // queries HTML elements that contain `data-id` value that maps to the section id from Shopify

    this.sections = Array.from(document.querySelectorAll("[data-id]")).map(section => section.dataset.id); // instance of DOM Parser API

    this.parser = new DOMParser();
  } // takes either a string or a string array of section id values that will be added to the sections array.


  addSections(sections) {
    var ids = Array.isArray(sections) ? sections : sections.replace(/\s/g, "").split(",");
    this.sections = this.sections.concat(ids);
  } // takes the sections object returned from the Section Rendering API result within the HTTP response object and attempts to render the DOM.


  renderSections(sections) {
    if (!sections) return;

    for (var [id, html] of Object.entries(sections)) {
      this.renderSection(id, html);
    }
  } // takes a Shopify section id along with the html text string and attempts to render the DOM with that string.


  renderSection(id, html) {
    var _section$querySelecto, _section$querySelecto2, _element$querySelecto;

    var section = this.parser.parseFromString(html, "text/html");
    var sectionHTML = (_section$querySelecto = (_section$querySelecto2 = section.querySelector(".js-contents")) == null ? void 0 : _section$querySelecto2.innerHTML) != null ? _section$querySelecto : section.textContent;
    if (!sectionHTML) return;
    var element = document.querySelector("#shopify-section-" + id);
    if (!element) return;
    var container = (_element$querySelecto = element.querySelector(".js-contents")) != null ? _element$querySelecto : element;
    if (!container) return;
    container.innerHTML = sectionHTML;
  } // takes a Shopify product's variant id along with a quantity and makes a HTTP POST request to the `cart/add` endpoint.


  addItem(variantId, quantity) {
    var _this = this;

    return _asyncToGenerator(function* () {
      var request = yield fetch(_this.route + "cart/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          sections: _this.sections
        })
      });
      var response = yield request.json();

      _this.renderSections(response.sections);

      return response;
    })();
  } // takes a Shopify product's variant id along with a 0 quantity and makes an HTTP POST request to the `cart/change` endpoint.


  removeItem(variantId) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      return yield _this2.updateItem({
        id: variantId,
        quantity: 0
      });
    })();
  } // takes a Shopify product's variant id along with a quantity and makes an HTTP POST request to the `cart/change` endpoint.


  updateItem(item) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      var request = yield fetch(_this3.route + "cart/change", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(Object.assign({}, item, {
          sections: _this3.sections
        }))
      });
      var response = yield request.json();

      _this3.renderSections(response.sections);

      return response;
    })();
  } // takes an object containing key-value pairs where the key is a Shopify product variant id and the value is the quantity and makes an HTTP POST request to the `cart/update` endpoint.


  updateItems(items) {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      var request = yield fetch(_this4.route + "cart/update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(Object.assign({}, items, {
          sections: _this4.sections
        }))
      });
      var response = yield request.json();

      _this4.renderSections(response.sections);

      return response;
    })();
  } // Makes an HTTP GET request to the `/cart` endpoint to fetch the updated Shopify customer cart.


  getCart() {
    var _this5 = this;

    return _asyncToGenerator(function* () {
      var result = yield fetch(_this5.route + "cart", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      });
      if (result.status === 200) return result.json();
      throw new Error("Failed to get request, Shopify returned " + result.status + " " + result.statusText);
    })();
  }

}